import { render } from "./RequestResetPage.vue?vue&type=template&id=42099cd6&scoped=true"
import script from "./RequestResetPage.vue?vue&type=script&lang=js"
export * from "./RequestResetPage.vue?vue&type=script&lang=js"

import "./RequestResetPage.vue?vue&type=style&index=0&id=42099cd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42099cd6"]])

export default __exports__